import { useCallback, useEffect, useState } from "react";
import { VerificationQueueData, VerificationQueueStatus, fetchVerificationQueue } from "../services/verificationAdminService";

export function useVerificationQueue(status: VerificationQueueStatus) {
  const [data, setData] = useState<VerificationQueueData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchVerificationQueue(status));
    } catch {
      setData(null);
      setError("Unable to load verification queue. Check Cloud Function deployment and admin permissions.");
    } finally {
      setIsLoading(false);
    }
  }, [status]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    refresh
  };
}
